import React, { Component, PropTypes } from 'react';
import { DragLayer } from 'react-dnd';
import { ItemTypes } from '../constants';
import shallowCompare from 'react-addons-shallow-compare';
import PointDragPreview from './PointDragPreview';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};

const collect = monitor => ({
  item: monitor.getItem(),
  itemType: monitor.getItemType(),
  initialOffset: monitor.getInitialSourceClientOffset(),
  currentOffset: monitor.getSourceClientOffset(),
  clientOffset: monitor.getClientOffset(),
  isDragging: monitor.isDragging(),
});

const getItemStyles = props => {
  const { initialOffset, currentOffset, clientOffset } = props;
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;

  // console.log("initialOffset", initialOffset)
  // console.log("clientOffset", clientOffset)
  // console.log("currentOffset", currentOffset)

  const gx = clientOffset.x - x;
  const gy = clientOffset.y - y;

  // TODO : 36 and 41 are magic numbers, width and height of icons

  let transform = props.item.point.coordinate
    ? `translate(${x + gx - 32}px, ${y + gy - 40}px)`
    : `translate(${x + (gx - 32)}px, ${y + (gy - 40)}px)`;

  return {
    transform: transform,
    WebkitTransform: transform,
  };
};

class PointDragLayer extends Component {
  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  renderItem(type, item, taskType) {
    switch (type) {
      case ItemTypes.POINT:
        return <PointDragPreview point={item.point} taskType={taskType} />;
      default:
        return null;
    }
  }

  render() {
    const { item, itemType, isDragging, taskType } = this.props;

    if (!isDragging) {
      return null;
    }

    return (
      <div style={layerStyles}>
        <div style={getItemStyles(this.props)}>
          {this.renderItem(itemType, item, taskType)}
        </div>
      </div>
    );
  }
}

PointDragLayer.propTypes = {
  item: PropTypes.object,
  itemType: PropTypes.string,
  currentOffset: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }),
  isDragging: PropTypes.bool.isRequired,
  taskType: PropTypes.string.isRequired,
};

export default DragLayer(collect)(PointDragLayer);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/components/PointDragLayer.js